module.exports = __webpack_public_path__ + "img/folios-icon-active.17ef19f8.svg";